import React from 'react';

import { SubscriptionDetailsType } from '@portals/api/partners';
import { DetailsList, DetailsListProps } from '@portals/framework';
import {
  formatDateTime,
  getPaymentMethodDisplayName,
  getProductPriceDisplayText,
} from '@portals/utils';

interface OverviewTabProps {
  subscription: SubscriptionDetailsType | undefined;
}

export function OverviewTab({ subscription }: OverviewTabProps) {
  if (!subscription) return null;

  const priceText = getProductPriceDisplayText({
    pricingModel: subscription.product.pricing_model,
    currency: subscription.currency,
    usageBasedPriceInScu: subscription.usage_based?.usage_based_price_in_scu,
    usageBasedUnitName: subscription.product.usage_based_unit_name,
    amountInScu: subscription.amount_in_scu,
    paymentInterval: subscription.payment_interval,
  });

  const detailsListItems: DetailsListProps['items'] = [
    {
      label: 'Price',
      value: priceText,
    },
    {
      label: 'Date placed',
      value: formatDateTime(subscription?.created_at),
    },
    {
      label: 'Next billing date',
      value: subscription?.next_charge_at
        ? formatDateTime(subscription?.next_charge_at)
        : '--',
    },
    {
      label: 'Payment method',
      value: subscription
        ? getPaymentMethodDisplayName(subscription?.payment_method)
        : null,
    },
    {
      label: 'Customer',
      value: subscription?.organization?.display_name,
    },
    {
      label: 'ID',
      value: subscription?.id,
    },
  ];

  return <DetailsList items={detailsListItems} />;
}
